import http from "../Http/Http-processcommon";
const NombreDelModulo = "SesionProgramada";

class SesionDataService {

    async getSesionProgramadaByKeyUri(KeyUri) {
        return await http.get(`/${NombreDelModulo}/GetSesionProgramadaByKeyUri?KeyUri=${KeyUri}`);
    }

    async getSesionById(Id) {
        return await http.get(`/${NombreDelModulo}/GetSesionById?Id=${Id}`);
    }
}

export default new SesionDataService();
